import React from'react';
import {observer} from 'mobx-react-lite'
import clubStore from "../../../storage/ClubStore";
import appStore from "../../../storage/AppStore";
import Input from "../../../ui/Input";
import ClickableMap from "../../../ui/ClickableMap";
import Btn from "../../../ui/Btn";
import systemStore from "../../../storage/SystemStore";
import MultipleSelect from '../../../ui/MultipleSelect'
import {useNavigate} from "react-router";

const Branch = () => {
    const navigate = useNavigate();
  return (
    <div className="row justify-content-center">
      <h3 className="text-center pb-2 pb-sm-3 mt-lg-3 mt-xl-4">{clubStore.branch.id ? appStore.tr.edit : appStore.tr.add_branch}</h3>
      <div className="col-12 px-3">
          <form className={`needs-validation${clubStore.branch.was_validated ? ' was-validated' : ''}`} noValidate="">
              <div className="row g-4">
                  <div className="col-12">
                      <label htmlFor="input_name" className="form-label">{appStore.tr.name} *</label>
                      <Input id={'input_name'} store={clubStore.branch} prop={'name'}
                             label={appStore.tr.name} required/>
                  </div>
                  <div className="col-12">
                      <label htmlFor="select_sports" className="form-label">{appStore.tr.sport_types} *</label>
                      <MultipleSelect
                          id={'select_sports'}
                          placeholder={appStore.tr.please_select}
                          label={appStore.tr.sport_types}
                          store={clubStore.branch}
                          prop={'sports'}
                          options={appStore.sports}
                        />
                  </div>
                  <div className="col-12">
                      <label htmlFor="input_address" className="form-label">{appStore.tr.address} *</label>
                      <Input id={'input_address'} store={clubStore.branch} prop={'address'}
                             label={appStore.tr.address} required/>
                  </div>
                  <div className="col-12 p-5">
                      <ClickableMap
                          center={[42.847723378643614, 74.59883964450174]}
                          zoom={12}
                          store={clubStore.branch}
                          prop={'location'}
                      />
                  </div>
                  <div className="col-12 text-center pt-2 pb-3">
                  <Btn
                      className="btn btn-primary"
                      onClick={() => {
                        clubStore.saveBranch()
                            .then(() => {
                                systemStore.setSuccess(appStore.tr.successfully_saved);
                                navigate('/manager/branch/list');
                            })
                            .catch((error) => {if (error) {systemStore.setError(appStore.tr[error.message] || error.message)}})
                      }}>{clubStore.branch.id ? appStore.tr.edit : appStore.tr.add_branch}</Btn>
                </div>
              </div>
          </form>
      </div>
    </div>
  );
};

export default observer(Branch);